export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Loader.vue?vue&type=template&id=360e3290&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Loader.vue?vue&type=template&id=360e3290&scoped=true&
// module id = null
// module chunks = 